import React, { useState, useEffect, useRef, useContext } from "react";

// Librerias de componentes
import { Button } from "primereact/button";

import Card from "../../../Components/Card/Card";
import AgGrid from "../../../Components/Tables/AgGrid/AgGrid";
import { setTitlePage } from "../../../Services/Config/ConfigService";
import { getLabel } from "../../../Services/Language/LanguageService";
import { baseLang } from "../../../Lang/BaseLang";
import { AuthContext } from "../../../Context/AuthContext/AuthContext";
import { ConfigContext } from "../../../Context/ConfigContext/ConfigContext";

import { getRoles } from "../../../API/IT/Roles/RolesRequests"; 

import RolCrudModal from "./ModalRoles/RolModalCrud";
import ModalAccesosPermisos from "./ModalRoles/ModalAccesosPermisos";


export const RolesScreen = () => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [roles, setRoles] = useState("");
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [accessPermissionEdit, setaccessPermissionEdit] = useState(null);

  const getInfo = async () => {
    setLoading(true);
    const r = await getRoles();
    setRoles(r);
    setLoading(false);
  };

  const colums = [
    {
      field: "IdRol",
      header: "ID",
      headerEn: "ID",
      width: 100,
      hidden: userAuth.IdRol === 1,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Rol",
      header: "Rol",
      headerEn: "Role",
      flex: 1,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Description",
      header: "Descripción",
      headerEn: "Description",
      flex: 1,
    },
    {
      field: "IdRol",
      className: "",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          className: "custom-tooltip",
          onClick: (rowData) => {
            setShowDialog(true);
            setSelected(rowData);
          },
          tooltipOptions: {
            position: "left",
          },
        },
        {
          icon: "ri-user-settings-line",
          tooltip: "Permisos",
          onClick: (rowData) => {
            setaccessPermissionEdit(rowData);
          },
          tooltipOptions: {
            position: "left",
          },
        },
      ],
    },
  ];

  const table = {
    Columns: colums,
    Data: roles,
    loading: loading,
  };

  useEffect(() => {
    getInfo();
    setTitlePage("Roles");
  }, []);

  return (
    <div
      className=" p-fluid"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      {/* <Toast ref={toast}></Toast> */}
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "rol", config.language)}</h3>
            <Button icon="pi pi-refresh" onClick={getInfo} />
            <Button
              icon="pi pi-plus"
              severity="success"
              onClick={() => {
                setShowDialog(true);
                setSelected(null);
              }}
            />
          </div>
        }
        contenido={
          <div className="pt-4" style={{ height: "90vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />
      {showDialog && (
        <RolCrudModal
          // toastRef={toast}
          rolesDialog={showDialog}
          rol={selected}
          setRolesDialog={setShowDialog}
          getRol={getInfo}
          modo={selected ? "Editar" : "Crear"}
        />
      )}
      <ModalAccesosPermisos
        accessPermissionEdit={accessPermissionEdit}
        setaccessPermissionEdit={setaccessPermissionEdit}
      ></ModalAccesosPermisos>
    </div>
  );
};

export default RolesScreen;
